import React, { useEffect } from 'react';
import { AutoConfirmedAlert } from '@adjust/dashboard-components';

import { SidebarId } from '@react/constants/sidebars';
import { Trace, TraceStatus } from '@redux/types';

import { TwoFactorConfigurationContent } from './TwoFactorConfigurationContent';

export interface TwoFactorConfigurationStateProps {
  isAlertOpen: boolean;
  trace: Trace;
  enabled: boolean;
  isLoading: boolean;
}

export interface TwoFactorConfigurationDispatchProps {
  fetchData: () => void;
  toggleConfig: (enable: boolean) => void;
  resetState: () => void;
  closeAlert: () => void;
}

export interface TwoFactorConfigurationOwnProps {
  closeSidebar: () => void;
}

type TwoFactorConfigurationProps = TwoFactorConfigurationStateProps &
  TwoFactorConfigurationDispatchProps &
  TwoFactorConfigurationOwnProps;

export const TwoFactorConfiguration: React.FC<TwoFactorConfigurationProps> = ({
  isLoading,
  enabled,
  trace,
  fetchData,
  toggleConfig,
  closeAlert,
  resetState,
  closeSidebar,
  isAlertOpen,
}) => {
  useEffect(() => {
    fetchData();
    return resetState;
  }, [fetchData, resetState]);

  const onToggle = (enabled: boolean) => {
    toggleConfig(enabled);
  };

  const onConfirmAlert = () => {
    if (trace.status === TraceStatus.Info) {
      closeSidebar();
    } else {
      closeAlert();
    }
  };

  return (
    <div className="flex-box-column flex-one content-panel sso-configuration">
      <TwoFactorConfigurationContent
        isLoading={isLoading}
        closeSidebar={closeSidebar}
        enabled={enabled}
        onToggle={onToggle}
      />
      <AutoConfirmedAlert
        parentSidebarId={SidebarId.TwoFactorAuth}
        isOpen={isAlertOpen}
        type={trace.status}
        message={trace.message}
        onConfirm={onConfirmAlert}
      />
    </div>
  );
};
